import classNames from "utilities/ClassNames";

export const AddNewItemBtn = ({
  onClick,
  btnType,
  type,
  isDisabled,
  children,
  className
}: {
  onClick?: () => void;
  btnType: 'filled' | 'hollow';
  type: 'submit' | 'button';
  isDisabled: boolean;
  children: React.ReactNode; // This can be any valid React child (text, JSX, components)
  className?: string;
}) => {
  const btnClasses = {
    filled: isDisabled ? 'bg-[#2A2A2A]' : 'bg-[#2A2A2A] hover:bg-[#3a3a3a33] ',
    hollow: isDisabled ? 'border-2 border-[#8A8A8A]' : 'border-2 border-blue',
  };
  return (
    <button
      type={type}
      className={classNames(
        btnClasses[btnType],
        isDisabled ? "cursor-default" : "cursor-pointer",
        `${className} flex flex-row items-center gap-2 rounded-lg p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white`
      )}
      onClick={isDisabled ? () => null : onClick}
    >
      {children} {/* Render any children passed to the button */}
    </button>
  );
};
